export default __webpack_public_path__ + "static/media/p02 p01.cd447beb.jpg";